var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4362 4.7636C11.7877 5.11508 11.7877 5.68492 11.4362 6.0364L8.4726 9L11.4362 11.9636C11.7877 12.3151 11.7877 12.8849 11.4362 13.2364C11.0847 13.5879 10.5149 13.5879 10.1634 13.2364L6.56341 9.6364C6.21194 9.28492 6.21194 8.71508 6.56341 8.3636L10.1634 4.7636C10.5149 4.41213 11.0847 4.41213 11.4362 4.7636Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.0b53deb7ca0d197b0efe48b20917b70b.svg";
export { ForwardRef as ReactComponent };